import script from "./in-person-interview-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./in-person-interview-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__